export default {
	data() {
		return {
			page: 1,
		};
	},
	methods: {
		nextPage() {
			this.page++;
		},
	},
};
